import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/blogs/BlogContent.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/blogs/CategoryTab.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/common/CommunitySection.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/common/whatsapp.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/events/hero/HeroSection.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/script.js");
